export function parseQueryString() {
  const queryParams = new URLSearchParams(window.location.search.slice(1));
  return Object.fromEntries(queryParams.entries());
}
